const surveyConfig = {
	type: 'ipass',
    mode: 'tabbed',
    cols: 1,
    title: "IPASS: Colpuno Newsletter Registration",
    linkHeaderImage: "https://www.colpuno.com",
    tabs: [
        { key: 'newsletter', title: 'Newsletter Registration' },
    ],
    conclusion: { 
        label: "Privacy Policy",
        title: "Thank you for your interest.",
        description: "",
        showInviter: true,
    },
    finished: {
        tick: true,
        title: "Thank you for signing up. We will send you updates about Colpuno.",
        description: "",
    },
};
const surveyFields = [];

surveyFields.push({ key: 'newsletter', tab: 'newsletter', type: 'group', label: "Newsletter Registration", cols: 2, items: [
    { key: 'email', type: 'email', label: "Email", required: true, colSpan: 2 },
    { key: 'get_updates_info', type: 'info', label: "Please enter your email address to receive helpful career insights from Colpuno and claim your free access.", colSpan: 2 },
    { key: 'first_name', type: 'text', label: "First name", required: true },
    { key: 'last_name', type: 'text', label: "Last name", required: true },
    { key: 'nurse_type', type: 'select', label: "Are you a nurse?", required: true, colSpan: 2,options: [ 'Not|Not a nurse', 'Train|In training to become a nurse', 'Nurse|I am a nurse' ] },
]});

export default { surveyConfig, surveyFields };